/**
 * StatusBadge — colored pill for various CC / approval / renewal statuses.
 * Maps a status string to a deterministic color set.
 */

import { FunctionComponent } from "react";

interface Props {
  status?: string;
  className?: string;
}

const palette = (status?: string): { bg: string; text: string } => {
  const s = (status || "").toLowerCase();
  if (s.includes("approved") || s === "active" || s.includes("open"))
    return { bg: "bg-green-50", text: "text-green-700" };
  if (s.includes("rejected") || s.includes("renewal rejected"))
    return { bg: "bg-rose-50", text: "text-rose-700" };
  if (s.includes("pending renewal"))
    return { bg: "bg-amber-50", text: "text-amber-700" };
  if (s.includes("pending"))
    return { bg: "bg-blue-50", text: "text-blue-700" };
  if (s.includes("closed"))
    return { bg: "bg-gray-100", text: "text-gray-600" };
  return { bg: "bg-gray-100", text: "text-gray-700" };
};

const StatusBadge: FunctionComponent<Props> = ({ status, className }) => {
  if (!status) return null;
  const { bg, text } = palette(status);
  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium ${bg} ${text} ${
        className || ""
      }`}
    >
      {status}
    </span>
  );
};

export default StatusBadge;
